export const NO_SIZE_SENTINEL = 'NOSIZE';
export const CLOTHING_SIZES = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL', '6XL', '7XL'];
const NO_SIZE_TOKENS = new Set(['NOSIZE', 'FREE', 'OS', 'ONESIZE']);

const normalizeName = (name = '') =>
  String(name)
    .toLowerCase()
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

export const isSizelessCategoryName = (name = '') => {
  const n = normalizeName(name);
  if (!n) return false;
  return /\bsarees?\b/.test(n) || /\bsaris?\b/.test(n) || /\bunstitched\b/.test(n);
};

const entityName = (value) => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  return value.name || '';
};

export const productAllowsOptionalSize = (product) =>
  isSizelessCategoryName(entityName(product?.category)) ||
  isSizelessCategoryName(entityName(product?.subcategory));

export const normalizeSizeToken = (size) =>
  String(size || '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '');

export const isNoSizeValue = (size) => {
  const token = normalizeSizeToken(size);
  return !token || NO_SIZE_TOKENS.has(token);
};

export const clothingSizes = (sizes) =>
  (Array.isArray(sizes) ? sizes : sizes ? [sizes] : []).filter((size) =>
    CLOTHING_SIZES.includes(normalizeSizeToken(size))
  );

export const productHasClothingSizes = (product) => clothingSizes(product?.sizes).length > 0;

export const formatSizeLabel = (size) =>
  isNoSizeValue(size) ? 'Without size' : String(size || '').trim();

export const cartSizeLabel = (size) => (isNoSizeValue(size) ? '' : String(size || '').trim());

export const defaultCartSize = (product) => clothingSizes(product?.sizes)[0] || '';
